import { group as d3Group } from "d3-array";
import saveAs from "file-saver";
import JSZip from "jszip";
import printJS from "print-js";
import { Entidad } from "../../../data/Entidad";
import { MFinanzaIngresoPagoRecibido } from "../../../data/model/MFinanzaIngresoPagoRecibido";
import { _DICC_ALUMNO, _LOCALDATA_GetTutoresDeAlumno } from "../../../data/modulo/Alumno";
import { _DICC_ESCUELA } from "../../../data/modulo/Escuela";
import { _SvNoticiaNueva, IMapSendCincularItems } from "../../../data/modulo/Noticia";
import { DataUtilAlertBot } from "../../../data/util/AlertBot";
import { ArrayV2 } from "../../../util/ArrayV2";
import { DateV2 } from "../../../util/DateV2";
import _L from "../../../util/Labels";
import { Button } from "../../controlD3/Button";
import { List } from "../../controlD3/List";
import { _ModalConfirmacion } from "../../controlD3/ModalThings/ModalConfirmacion";
import { _ModalServiceIteratorBasic } from "../../controlD3/ModalThings/ModalServiceIteratorBasic";
import { _ModalToAProccess } from "../../controlD3/ModalThings/ModalToAProccess";
import { NotificacionV2 } from "../../controlD3/NotificacionV2";
import { PDFThings } from "../../controlD3/PDFBuilder";
import { HTMLTooltipComponent } from "../../controlWC/TooltipComponent";
import { UIUtilFormat } from "../../util/Format";
import { UIUtilIconResources } from "../../util/IconResourses";
import { UIUtilTime } from "../../util/Time";
import { UIUtilGeneral } from "../../util/Util";
import { UIUtilViewEscuelas } from "../Escuelas/Util";

export function _GenerarResumenPDFModal(datos: MFinanzaIngresoPagoRecibido[]) {
    type IAlumno = Entidad.IAlumno;
    type ItemAlumno = Pick<IAlumno, "IdChild" | "NombreCompleto"> & {
        Selected: boolean;
        IdEscuela: number;
        PDF: jspdf.jsPDF;
        PDFStatus: number;
        PDFFileName: string;
        AlumnoDescripcion: string;
    };
    const manySchools: boolean = d3Group(datos, (d: MFinanzaIngresoPagoRecibido) => d.IdEscuela).size > 1;
    const dataPorAlumno: Map<number, MFinanzaIngresoPagoRecibido[]> = d3Group(datos, (d: MFinanzaIngresoPagoRecibido) => d.IdAlumno);
    const dataAlumnosList = new ArrayV2<ItemAlumno>();
    dataPorAlumno.forEach((pagos, idAlumno) => {
        const alumno = _DICC_ALUMNO.get(idAlumno);
        let strDescripcion = "";
        if (alumno.Matricula) {
            strDescripcion += _L("alumnos.d_field_matricula") + ": " + alumno.Matricula + "\n";
        }
        if (manySchools) {
            strDescripcion += _L("finanzaspagosrecibidos.d_field_strescuela") + ": " + alumno.NombreKinder;
        }
        dataAlumnosList.push({
            IdChild: idAlumno,
            IdEscuela: pagos[0].IdEscuela,
            NombreCompleto: pagos[0].NombreCompletoAlumno,
            Selected: false,
            PDF: null,
            PDFStatus: 0,
            PDFFileName: _L("finanzaspagosrecibidos.resumen_title") + " - " + pagos[0].NombreCompletoAlumno + ".pdf",
            AlumnoDescripcion: strDescripcion,
        })
    })
    _ModalToAProccess({
        Title: _L("finanzaspagosrecibidos.generarresumen_title"),
        Width: 1000,
        Height: "800px",
        DrawContent: (content, mt) => {
            content.classed(UIUtilGeneral.FBoxOrientation.Horizontal, true);
            let divPadre = content.append("div");
            divPadre.classed("divPadreLateral", true);
            const ctrlList = new List<ItemAlumno>()
                ._SetParent(divPadre.node())
                ._SetCreateTemplate((itemContainer, d) => {
                    let lbl = itemContainer
                        .classed(UIUtilGeneral.FBoxOrientation.Horizontal, true)
                        .classed(UIUtilGeneral.FBoxAlign.SpacebetweenCenter, true)
                        .append("label")
                    lbl.append("span")
                        .attr("id", "name");
                    lbl.append("pre")
                        .attr("id", "description")
                })
                ._SetUpdateItem((itemContainer, d) => {
                    itemContainer.select("#name")
                        .text(d.NombreCompleto);
                    itemContainer.select("#description")
                        .text(d.AlumnoDescripcion);
                    itemContainer.on("click", async (d) => {
                        if (!d.Selected) {
                            dataAlumnosList.forEach(d => d.Selected = false);
                            d.Selected = true;
                            if (!d.PDF || d.PDFStatus != 1) {
                                await fnAlumnoPDFBuild(d);
                            }
                            else {
                                ctrlList._RefreshList();
                                PDFThings._PDFViewer(d.PDF, pdfViewerContainer.node())
                            }
                        }
                    })

                    if (d.Selected) {
                        if (!itemContainer.select(".opciones").node()) {
                            itemContainer.style("background-color", "var(--color_primary2)");

                            const opcionesContainer = itemContainer.append("div")
                                .attr("class", "opciones")
                                .classed(UIUtilGeneral.FBoxOrientation.Horizontal, true)
                                .classed(UIUtilGeneral.FBoxAlign.EndCenter, true)
                                .style("min-width", "min-width")
                                .style("gap", "var(--padding1)");

                            const tooltipElement = itemContainer.append<HTMLTooltipComponent>("wc-tooltip").node()
                            if (d.PDFStatus == -2) {
                                tooltipElement._SetObservedElementsAdvanced({
                                    Target: opcionesContainer.append("img")
                                        .attr("class", "btn_round")
                                        .attr("src", UIUtilIconResources.CGeneral.Sync)
                                        .attr("draggable", false)
                                        .on("click", async () => {
                                            await fnAlumnoPDFBuild(d);
                                        })
                                        .node(),
                                    Text: _L("finanzaspagosrecibidos.rebuildlogopdf"),
                                })
                            }
                            tooltipElement._SetObservedElementsAdvanced(
                                {
                                    Target: opcionesContainer.append("img")
                                        .attr("class", "btn_round")
                                        .attr("src", UIUtilIconResources.CGeneral.Print)
                                        .attr("draggable", false)
                                        .on("click", () => {
                                            let uri = d.PDF.output("bloburi");
                                            printJS({
                                                printable: uri,
                                                type: "pdf",
                                                showModal: true
                                            });
                                        })
                                        .node(),
                                    Text: _L("general.print"),
                                },
                                {
                                    Target: opcionesContainer.append("img")
                                        .attr("class", "btn_round")
                                        .attr("src", UIUtilIconResources.CGeneral.Download)
                                        .attr("draggable", false)
                                        .on("click", () => d.PDF.save(d.PDFFileName))
                                        .node(),
                                    Text: _L("general.descargar"),
                                },
                                {
                                    Text: _L("finanzaspagosrecibidos.enviartutor"),
                                    Target: opcionesContainer.append("img")
                                        .attr("class", "btn_round")
                                        .attr("src", UIUtilIconResources.CGeneral.Circular2)
                                        .attr("draggable", false)
                                        .on("click", async () => {
                                            _ModalConfirmacion({
                                                Title: _L("finanzaspagosrecibidos.title_confirm_envio"),
                                                Message: _L("finanzaspagosrecibidos.confirm_envio_circular"),
                                                OnAccept: async (mt) => {
                                                    mt.Progress.attr("oculto", false);
                                                    mt.Modal._DeshabilitarBtns();
                                                    let blob = d.PDF.output("blob")
                                                    let res = await _SvNoticiaNueva("ByAlumnos", <IMapSendCincularItems["ByAlumnos"]>{
                                                        IdEscuela: d.IdEscuela,
                                                        Titulo: _L("finanzaspagosrecibidos.resumen_pago"),
                                                        Mensaje: _L("finanzaspagosrecibidos.resumen_pago") + " - " + d.NombreCompleto,
                                                        Archivo: new File([blob], d.PDFFileName, { "type": blob.type }),
                                                        Programado: null,
                                                        ReqAutorizacion: false,
                                                        IdAlumnos: [d.IdChild]
                                                    });
                                                    mt.Progress.attr("oculto", true);
                                                    mt.Modal._HabilitarBtns();
                                                    if (res.Resultado > 0) {
                                                        NotificacionV2._Mostrar(_L("finanzaspagosrecibidos.success_process"), "INFO");
                                                    }
                                                    else {
                                                        NotificacionV2._Mostrar(_L("finanzaspagosrecibidos.fail_process"), "ADVERTENCIA");
                                                    }
                                                },
                                            })
                                        })
                                        .node(),
                                },
                            );
                        }
                    }
                    else {
                        itemContainer.style("background-color", null)
                        itemContainer.select(".opciones").remove();
                        itemContainer.select("wc-tooltip").remove();
                    }

                })
                ._SetItems(dataAlumnosList);

            let divButtons = divPadre.append("div");
            divButtons.classed("divButtons", true);

            new Button(divButtons.node(), _L("general.descargartodo"))
                ._d3Selection
                .on("click", () => {
                    fnBuildAndDownloadAllPDF();
                });

            new Button(divButtons.node(), _L("finanzaspagosrecibidos.enviartutores"))
                ._d3Selection
                .on("click", async () => {
                    mt.Progress.attr("oculto", false);
                    mt.Modal._DeshabilitarBtns();
                    let arrErr: ItemAlumno[] = [];
                    await dataAlumnosList._ForEachAwait(async (d) => {
                        await fnAlumnoPDFBuild(d, false);
                        if (!d.PDF || d.PDFStatus != 1) {
                            arrErr.push(d);
                            return;
                        }
                    });
                    if (arrErr.length > 0) {
                        NotificacionV2._Mostrar(_L("finanzaspagosrecibidos.pdf_fail_construct"), "ADVERTENCIA");
                        mt.Progress.attr("oculto", true);
                        mt.Modal._HabilitarBtns();
                        return;
                    }
                    // ModalThings._OpenModalToProccessServiceByServiceFromAArrayBasic({
                    _ModalServiceIteratorBasic({
                        Title: _L("finanzaspagosrecibidos.title_confirm_envio"),
                        Message: _L("finanzaspagosrecibidos.confirm_envio_circulares"),
                        DataToProccess: dataAlumnosList,
                        Width: 400,
                        OnStepAProccess: async (d) => {
                            let blob = d.PDF.output("blob");
                            return _SvNoticiaNueva("ByAlumnos", <IMapSendCincularItems["ByAlumnos"]>{
                                IdEscuela: d.IdEscuela,
                                Titulo: _L("finanzaspagosrecibidos.resumen_pago"),
                                Mensaje: _L("finanzaspagosrecibidos.resumen_pago") + " - " + d.NombreCompleto,
                                Archivo: new File([blob], d.PDFFileName, { "type": blob.type }),
                                Programado: null,
                                ReqAutorizacion: false,
                                IdAlumnos: [d.IdChild]
                            })
                        },
                        OnError_GetItemDataTag: (d) => {
                            return `${d.NombreCompleto}`;
                        },
                        TypeRequest: null,
                    })
                    mt.Progress.attr("oculto", true);
                    mt.Modal._HabilitarBtns();
                });

            const pdfViewerContainer = content.append("div")
                .classed("pdfViewerContainer", true)

            const fnAlumnoPDFBuild = async (d: ItemAlumno, showProgres = true) => {
                if (!d.PDF || d.PDFStatus != 1) {
                    if (showProgres) mt.Progress.attr("oculto", false);
                    let [pdf, result] = await GetPDFBuilded(d.IdChild, d.NombreCompleto, d.IdEscuela, d.PDFFileName);
                    d.PDF = pdf;
                    d.PDFStatus = result;
                    if (showProgres) mt.Progress.attr("oculto", true);
                    if (d.Selected) {
                        ctrlList._RefreshList();
                        PDFThings._PDFViewer(d.PDF, pdfViewerContainer.node());
                    }
                }
            }
            const fnBuildAndDownloadAllPDF = async () => {
                const resultFolderName = _L("finanzaspagosrecibidos.resumen_title") + " " + UIUtilTime._GetValidatorDateYMD(new Date());
                const zip = new JSZip();
                const resumenFolder = zip.folder(resultFolderName);
                mt.Progress.attr("oculto", false);
                await dataAlumnosList
                    ._ForEachAwait(async (d) => {
                        await fnAlumnoPDFBuild(d, false);
                        let blob = d.PDF.output("blob")
                        resumenFolder.file(d.PDFFileName, blob);
                    })
                zip.generateAsync({ type: "blob" })
                    .then(function (content) {
                        saveAs(content, resultFolderName);
                    })
                    .catch((e) => {
                        DataUtilAlertBot._SendError(e, "Reporte pagos recib");
                        this.notificacion._Mostrar(_L("general.notif_fail"), "ADVERTENCIA");
                    })
                    .finally(() => {
                        mt.Progress.attr("oculto", true);
                    });
            }

            // Se inicializa con pagos de un solo alumno
            setTimeout(async () => {
                if (dataPorAlumno.size == 1) {
                    let alumno = dataAlumnosList[0];
                    alumno.Selected = true;
                    fnAlumnoPDFBuild(alumno);
                }
            });
        }
    });
    const GetPDFBuilded = (idAlumno: number, nombreAlumno: string, idEscuela: number, alumnoPDFFileTitle: string) => {
        const escuela = _DICC_ESCUELA.get(idEscuela);
        const tutores = Array.from(_LOCALDATA_GetTutoresDeAlumno(idAlumno).values())
            .map(d => d.NombreCompleto)
            .join(", ");
        const dtCurrent = new DateV2()
            ._SetTimeZone(escuela.ZonaHoraria);
        const pagosAlumno = dataPorAlumno.get(idAlumno);
        let totalPago = 0;
        pagosAlumno.forEach(d => {
            totalPago += d.ValorPago;
        })

        return PDFThings._PDFCreate({
            Title: _L("finanzaspagosrecibidos.resumen_title"),
            Logo: escuela.Logo,
            IncDescription: _L("general.fecha") + ": " + UIUtilTime._DateFormatStandar(dtCurrent) + "\n\n"
                + escuela.Nombre + "\n"
                + UIUtilViewEscuelas._BuildDirectionString(escuela) + "\n"
                + escuela.Telefono + "\n"
                + escuela.Correo + "\n\n"
                + _L("finanzaspagosrecibidos.resumen_alumno") + ": " + nombreAlumno + "\n"
                + _L("finanzaspagosrecibidos.resumen_tutor") + ": " + tutores,
            DataTable: pagosAlumno
                .map(d => ({
                    [_L("finanzaspagosrecibidos.d_field_idfolio")]: d.IDFolio,
                    [_L("finanzaspagosrecibidos.d_field_conceptocargo")]: d.ConceptoCargo,
                    [_L("finanzaspagosrecibidos.d_field_valorcargo")]: d.ValorCobrarTotalFmt,
                    [_L("finanzaspagosrecibidos.d_field_descuentototal")]: d.ValorDescuentoTotalFmt,
                    [_L("finanzaspagosrecibidos.d_field_metodopagonombre")]: d.MetodoPagoInfoCompleta,
                    [_L("finanzaspagosrecibidos.d_field_fecharegistro")]: d.FechaPagoFmt,
                    [_L("finanzaspagosrecibidos.d_field_valor")]: d.ValorPagoFmt,
                })),
            Resumen: {
                [_L("finanzaspagosrecibidos.tag_totalpagado")]: UIUtilFormat._CurrencyFmt(totalPago)
            },
            MetadataTitle: alumnoPDFFileTitle,
        })
    }
}